import React from 'react';
import { getResolvedPath } from '../../utils';
import { Link } from 'react-router-dom';
import ArtImageFallback from '../../components/ArtImageFallback';

const WarnDetail = ({ info }) => {
  const hasTerm = info?.term?.auction_name || info?.term?.imageInfo?.imageUrl;
  const hasUrl = info?.url?.auction_name || info?.url?.imageResult?.image_url;

  return (
    <div className="flex flex-col md:flex-row mt-5 border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm">
      <div className="w-full md:w-[45%] p-4">
        <Link to={`/artwork/name/${info.artworkId?._id}`}>
          <ArtImageFallback
            src={getResolvedPath(info?.artworkId?.images?.[0])}
            alt={info.artworkId?.name || ''}
            className="object-contain max-w-full max-h-full"
            wrapperStyle={{ width: '100%', minHeight: 200 }}
          />
        </Link>
        <p className="mt-2 font-semibold text-gray-900">{info.artworkId?.name}</p>
      </div>
      <div className="w-full md:w-[55%] p-4 space-y-4">
        {hasTerm && (
          <div className="border-t md:border-t-0 md:border-l border-gray-100 pt-4 md:pt-0 md:pl-4">
            <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">Term match</p>
            <p>
              <span className="text-red-500 font-semibold">{info.term.auction_name}</span>
              {info.term.auction_url && (
                <>
                  {' '}
                  (<span className="text-blue-500">{info.term.auction_url}</span>)
                </>
              )}
            </p>
            {info.term.imageInfo?.link && (
              <a href={info.term.imageInfo.link} target="_blank" rel="noreferrer" className="block mt-2">
                <ArtImageFallback
                  src={info.term.imageInfo.imageUrl}
                  alt=""
                  className="object-contain max-w-full max-h-full"
                  wrapperStyle={{ width: '100%', minHeight: 160 }}
                />
              </a>
            )}
            {info.term.imageInfo?.domain && (
              <p className="text-sm text-gray-500 mt-1">{info.term.imageInfo.domain}</p>
            )}
          </div>
        )}
        {hasUrl && (
          <div className="border-t border-gray-100 pt-4">
            <p className="text-xs uppercase tracking-wide text-gray-500 mb-1">Image match</p>
            <p>
              <span className="text-red-500 font-semibold">{info.url.auction_name}</span>
              {info.url.auction_url && (
                <>
                  {' '}
                  (<span className="text-blue-500">{info.url.auction_url}</span>)
                </>
              )}
            </p>
            {info.url.imageResult?.score != null && (
              <p className="text-sm text-gray-600 mt-1">Match score: {info.url.imageResult.score}</p>
            )}
            {info.url.imageResult?.domain && (
              <p className="text-sm text-gray-500">{info.url.imageResult.domain}</p>
            )}
          </div>
        )}
        {!hasTerm && !hasUrl && (
          <p className="text-sm text-gray-500">Alert recorded — no match detail available.</p>
        )}
      </div>
    </div>
  );
};

export default WarnDetail;
